// components/HeaderWithBack.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Confirm from '../components/modal/Confirm';
import axios from '../api/axios';

interface HeaderWithBackProps {
  title: string;
  url?: string;
  user_id?: number;
  teleconsult_id?: number;
  token?: string;
}

const HeaderWithBack: React.FC<HeaderWithBackProps> = ({ title, url, user_id, teleconsult_id, token }) => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const isDisclaimerRoute = url?.includes('/disclaimer/');

  const handleBack = () => {
    if (teleconsult_id) {
      setShowModal(true);
      return;
    }

    if (isDisclaimerRoute) {
      navigate("/home");
      return;
    }

    if (url) {
      navigate(url);
      return;
    }

    navigate(-1);
  };

  const handleConfirmExit = async () => {
    if (!teleconsult_id) {
      console.warn("teleconsult_id belum tersedia, skip cancel API")
      setShowModal(false)
      url ? navigate(url) : navigate("/home");
      return
    }
    
    setIsLoading(true);
    try {
      setShowModal(false);
      navigate('/home'); // navigasi setelah cancel berhasil
    } catch (error) {
      console.error('❌ Gagal membatalkan konsultasi:', error);
      alert('Terjadi kesalahan saat membatalkan konsultasi.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <nav className="sticky top-0 z-50 bg-white p-4 shadow-md flex items-center justify-center relative">
        <button
          onClick={handleBack}
          className="absolute left-4 text-white bg-teal-500 p-2 rounded-full"
        >
          <FaArrowLeft />
        </button>
        <h1 className="text-lg font-semibold">{title}</h1>
      </nav>

      <Confirm
        show={showModal}
        title="Batalkan Konsultasi"
        message="Keluar dari halaman ini akan membatalkan permintaan konsultasi. Yakin ingin keluar?"
        confirmText="Keluar"
        cancelText="Batal"
        onConfirm={handleConfirmExit}
        onCancel={() => setShowModal(false)}
        loading={isLoading}
      />
    </>
  );
};

export default HeaderWithBack;
